import React from 'react';
import './Destination.css';
import logo from '../Images/Logo_Invis.png';
import yachtVideo from '../Images/yacht.mp4';
import MovingBoatVid from '../../src/Images/MovingBoatVideo.mp4'
import countryImage from '../Images/CountryReplace.jpg';
import DestinationsVid from '../Images/Destinations/Destinations.mp4'
import HubMap from '../Components/HubMap/HubMap';

import InteractiveMap from './DestinationMap';
import Footer from '../Components/Footer/Footer'
import { Link } from "react-router-dom";

import Navbar from '../Components/Navbar/Navbar';
import islands from "../../src/data/IslandsData";


//Images
import AntiguaImg  from '../Images/Countries/anu.png';
import GrenadaImg  from '../Images/Countries/grenada.png';
import StLuciaImg  from '../Images/Countries/st lucia.png';
import StThomasImg from '../Images/Countries/st thomas.png';
import TTImg from '../Images/Countries/tt.png';
import StMaarteenImg from '../Images/Countries/St Maarten.png'


const gridImages = {
  antigua: AntiguaImg,
  grenada: GrenadaImg,
  stlucia: StLuciaImg,
  stThomas:  StThomasImg,
  trinidad: TTImg,
  stMarteen: StMaarteenImg,
};

// const slugify = s =>
//   s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "").trim();

// const countryData = [
//   { name: "Antigua", image: "/Images/islands/antigua-hero.jpg" },
//   { name: "Barbuda", image: "/Images/islands/barbuda-hero.jpg" },
//   { name: "St. Lucia", image: "/Images/islands/stlucia-hero.jpg" },
// ].map(c => ({ ...c, slug: slugify(c.name) }));

const gridItems = Object.entries(islands).map(([slug, v]) => ({
  slug,                 
  name: v.name,
  image:  gridImages[slug] || v.hero, 
}));



function Destination() {

  // const countryData = [
  //   { name: 'Antigua & Barbuda', image: anu },
  //   { name: 'Grenada', image: grenada },
  //   { name: 'St. Lucia', image: stLucia },
  //   { name: 'St. Thomas', image: stThomas },
  //   { name: 'Trinidad & Tobago', image: tt },
  //   { name: 'St. Maarten ', image: stMaarteen },
  // ];


  return (
    <div className="destinations-container">
      
    <Navbar/>
    

    {/* Video Banner */}
    {/* <div className="hero-banner">
      <video autoPlay loop muted className="hero-video" controls>
        <source src={yachtVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div> */}
    {/* <div className="destination-map-wrapper">
      <InteractiveMap />
      
    </div> */}
      <div className="hero-banner">
      <video
        className="hero-video"
        autoPlay
        muted
        loop
        playsInline
        src={DestinationsVid}
      />
      <div className="hero-overlay">
        <h1>Explore the Caribbean</h1>
      </div>
    </div>


    <section className="hubmap-section">
      <h2 className="hubmap-heading">
        Island Itineraries Within Manageable Time Frames
      </h2>

      <div className="hubmap-wrapper">
        <HubMap />
      </div>
    </section>

    {/* Curated Voyages Section */}
    <section className="voyages-intro">
      <div className="voyages-titlewrap">
        {/* <h2 className="voyages-heading">Curated Voyages, Timeless Experiences</h2> */}
        <p className="voyages-subheading">
          Island Itineraries Within Manageable Time Frames
        </p>
        <ul className="voyages-bullets">
          <li>Talk to our team to discuss your Itinerary support needs and we will  guide you throughout the Caribbean Island Chain.</li>
        </ul>

        

        <div className="destination-quicklinks">
          {gridItems.map(({ slug, name }) => (
            <Link key={slug} to={`/destinations/${slug}`} className="destination-pill">
              {name}
            </Link>
          ))}
        </div>

      </div>
      
      <p className="voyages-description">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus. 
        Vivamus commodo, sem at tincidunt mattis, arcu velit.
      </p>
      <p className='GetInTouch'>Get In Touch</p>
    </section>

    {/* Country Grid */}
    {/* <section className="country-grid">
        {countryData.map(({ slug, name, image }) => (
          <Link
            key={slug}
            to={`/destinations/${slug}`}   // <-- URL uses the slug key
            className="country-card"
            aria-label={`Go to ${name}`}
          >
            <img src={image} alt={name} />
            <div className="country-overlay">
              <h3>{name}</h3>
              <p>Contact Us</p>
            </div>
          </Link>
        ))}
      </section> */}


    {/* <section className="country-grid">
      {gridItems.map(({ slug, name, image }) => (
        <Link key={slug} to={`/destinations/${slug}`} className="country-card">
          <img src={image} alt={name} />
          <div className="country-overlay">
            <h3>{name}</h3>
            <p>Learn more</p>
          </div>
        </Link>
      ))}
    </section> */}

     <ul className="voyages-bullets">
        
        <li>Take advantage of our networked regional knowledge and fast track to the best services on your travels.</li>
        <li>Click on an Island for Destination Information
          <Link to="/contact" className="get-in-touch-link">
             Get in Touch
          </Link>
        </li>
        <li>Or just click on an island on the map!</li>
      </ul>

      <div className="services-directory-cta">
          <Link to="/directory" className="services-directory-link">
            Browse the Services Directory
          </Link>
      </div>
      
    <section className="ContactSection">
      <div className="ContactBox">
        <p className="ContactText">Contact our expert</p>
        <a className="GetInTouch" href="/contact">Get in touch</a>
      </div>
    </section>


      {/* Newsletter Section */}
      <section className="newsletter-section">
        <h2>Subscribe to our Newsletter</h2>
        <form className="newsletter-form">
          <input type="email" placeholder="Email address" required />
          <button type="submit">Subscribe</button>
        </form>
      </section>

      <section className='Destinations-testimonials'>
        <h2 className='Destinations-testimonials-title'>Testimonials</h2>
        <div className="Home2-testimonials-grid">
          <div className="Home2-testimonial-card">
            <p className="Home2-testimonial-text">
              “I will happily say my experience in dealing with Captain’s Connections and Mark Acosta were seamless and quite pleasurable, never one hiccup. We engaged Mark to be our agent in Antigua.... Our trip was St Thomas to Grenada  for hurricane season this last summer. His help began in St Martin and didn’t really end in Grenada. Everyone at every stop along the way knows and respects Mark, he is the guy. I never heard one negative comment regarding him.....He checked in with us at every stop, going down and returning to St Thomas. His service never ends, it’s not about the money with Mark, he really cares.”
            </p>
            <span className="Home2-testimonial-author">
              – Capt. Dan Knoop SY Pelican
            </span>
          </div>
        </div>
      </section>



      {/* Footer */}

      <Footer/>
      {/* <footer className="site-footer">
        <div className="footer-nav">
          <a href="/">Home</a>
          <a href="/services">Services</a>
          // <a href="/destinations">Destinations & Itinerary</a>
          <a href="/destinations-and-itineraries">Destinations & Itinerary</a>

        </div>

        <hr />
        <div className="footer-bottom">
          <div className="footer-contact">
            <h4>Get In Touch</h4>
            <p>For any questions feel free to <a href="/contact">Contact Us</a>.</p>
          </div>
          <img src={logo} alt="Captain’s Connections Logo" className="footer-logo-image" />
        </div>
      </footer> */}


     

    </div>
  );
}

export default Destination;
